// Routes des finances (zone Administration, lot L2-C partie A), raccordées par une ligne dans
// Application.tsx ; entrée de navigation « Finances » dans coquille/navigation.ts.
import type { RouteObject } from 'react-router';
import { PageAnomalie, PageAnomalies } from './PageAnomalies';
import { PageCaisse } from './PageCaisse';
import { PageCaisses } from './PageCaisses';
import { PageCatalogue } from './PageCatalogue';
import { PageCreance } from './PageCreance';
import { PageCreances } from './PageCreances';
import { PageListeRec } from './PageListeRec';
import { PagePaiement } from './PagePaiement';
import { PagePaiements } from './PagePaiements';
import { PageQuittances } from './PageQuittances';
import { PageRapprochements } from './PageRapprochements';
import { PageRecettes } from './PageRecettes';
import { PageReleve } from './PageReleve';
import { PageRemboursement, PageRemboursements } from './PageRemboursements';

export const routesRecettes: RouteObject[] = [
  { path: '/recettes', element: <PageRecettes /> },
  { path: '/recettes/indicateurs/:code', element: <PageListeRec /> },
  { path: '/recettes/catalogue', element: <PageCatalogue /> },
  { path: '/recettes/creances', element: <PageCreances /> },
  { path: '/recettes/creances/:id', element: <PageCreance /> },
  { path: '/recettes/paiements', element: <PagePaiements /> },
  { path: '/recettes/paiements/:id', element: <PagePaiement /> },
  { path: '/recettes/quittances', element: <PageQuittances /> },
  { path: '/recettes/caisses', element: <PageCaisses /> },
  { path: '/recettes/caisses/:id', element: <PageCaisse /> },
  { path: '/recettes/remboursements', element: <PageRemboursements /> },
  { path: '/recettes/remboursements/:id', element: <PageRemboursement /> },
  { path: '/recettes/rapprochements', element: <PageRapprochements /> },
  { path: '/recettes/rapprochements/:id', element: <PageReleve /> },
  { path: '/recettes/anomalies', element: <PageAnomalies /> },
  { path: '/recettes/anomalies/:id', element: <PageAnomalie /> },
];
